var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.99182 4.5C2.99182 4.22386 3.21568 4 3.49182 4H20.4918C20.768 4 20.9918 4.22386 20.9918 4.5C20.9918 4.77614 20.768 5 20.4918 5H3.49182C3.21568 5 2.99182 4.77614 2.99182 4.5ZM2.99182 11.5C2.99182 11.2239 3.21568 11 3.49182 11H20.4918C20.768 11 20.9918 11.2239 20.9918 11.5C20.9918 11.7761 20.768 12 20.4918 12H3.49182C3.21568 12 2.99182 11.7761 2.99182 11.5ZM3.49182 18C3.21568 18 2.99182 18.2239 2.99182 18.5C2.99182 18.7761 3.21568 19 3.49182 19H20.4918C20.768 19 20.9918 18.7761 20.9918 18.5C20.9918 18.2239 20.768 18 20.4918 18H3.49182Z"}));
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
